import { OpenReportAction, OpenReportTypes } from '../../types';
import { Reducer } from 'redux';

export const phoneNumberLoginState = {
  phoneNumber: '',
  pin: '',
};

export interface PhoneNumberLoginState {
  phoneNumber: string;
  pin: string;
}

const phoneNumberLoginReducer: Reducer<
  PhoneNumberLoginState,
  OpenReportAction
> = (
  state: PhoneNumberLoginState = phoneNumberLoginState,
  action: OpenReportAction,
): PhoneNumberLoginState => {
  switch (action.type) {
    case OpenReportTypes.PHONENUMBER_RESET:
      return phoneNumberLoginState;
    case OpenReportTypes.SET_LOGIN_PHONENUMBER:
      const loginUsername = action.payload.currentTarget.value;
      return {
        ...state,
        phoneNumber: loginUsername,
      };
    case OpenReportTypes.SET_LOGIN_PIN:
      const loginPassword = action.payload.currentTarget.value;
      return {
        ...state,
        pin: loginPassword,
      };
    default:
      return state;
  }
};

export default phoneNumberLoginReducer;
